import Image from "next/image";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useImagePreviewStore } from "@/lib/hooks/use-preview-image";

export const ImagePreview = () => {
  const { isOpen, imageUrl, altText, close } = useImagePreviewStore();

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent className="p-0 bg-transparent border-none">
        <div className="overflow-hidden rounded-lg">
          {imageUrl && (
            <Image
              src={imageUrl}
              alt={altText || "Image preview"}
              width={800}
              height={600}
              className="object-contain bg-black bg-opacity-50"
              priority
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
